module.exports = __webpack_public_path__ + "static/media/11.102.bd79aba2.webp";